import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CreateOrEditEventTypeDto, EventTypesServiceProxy, CreateOrEditCategoryDto } from '@shared/service-proxies/service-proxies';

import * as _ from 'lodash';

@Component({
    selector: 'createOrEditEventTypeModal',
    templateUrl: './create-or-edit-event-type-modal.component.html'
})

export class CreateOrEditEventTypeModalComponent extends AppComponentBase implements OnInit {

    @ViewChild('createOrEditModal') modal: ModalDirective;    
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;
    
    eventType: CreateOrEditEventTypeDto = new CreateOrEditEventTypeDto();

    constructor(
        injector: Injector,
        private _eventTypeService: EventTypesServiceProxy
    ) {
        super(injector);        
    }

    ngOnInit(): void {
        this.initialize();
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }
        
    close(): void {
        this.active = false;        
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();        
    }    

    initialize(): void {        
        this.eventType = new CreateOrEditEventTypeDto();
    }

    public show(eventTypeId?: number): void {        
        
        this.initialize();
        this.active = true;

        eventTypeId = eventTypeId ? eventTypeId : 0;

        this._eventTypeService.getEventTypeForEdit(eventTypeId).subscribe(result => {

            if (result.eventType)
                this.eventType = result.eventType;

            this.modal.show();            
        });
    }    

    save(): void {
        
        this._eventTypeService.createOrEdit(this.eventType)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/event-types/modal/create-or-edit-event-type-modal.component.ts